import { Environment, ENVIRONMENT } from '../index';
import { Provider } from '@angular/core';

export const provideEnvironment = (environment: Environment): Provider => ({
  provide: ENVIRONMENT,
  useValue: environment,
});
